module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "p-toolbar p-component mb-4"
  }, [_c('itemMasterdialog', {
    ref: "itemdialog"
  })], 1), _vm._v(" "), _c('itemMasterList', {
    on: {
      "delete-message": _vm.deleteMessage,
      "edit-item": _vm.editItemMaster,
      "view-item": _vm.viewItemMaster
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4716509e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/item/ItemMaster.vue
// module id = 2198
// module chunks = 0